import { render, staticRenderFns } from "./DeptPanel.vue?vue&type=template&id=1e0ef7c2&scoped=true"
import script from "./DeptPanel.vue?vue&type=script&lang=js"
export * from "./DeptPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ef7c2",
  null
  
)

export default component.exports